<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      employee: null,    // { id, name, code }
      history: [],
      loading: false,
    };
  },
  methods: {
    open(employee) {
      this.employee = employee;
      this.history = [];
      this.fetchHistory();
    },

    async fetchHistory() {
      if (!this.employee) return;
      this.loading = true;
      try {
        const res = await axios.get(`/hrms/employee-salaries/${this.employee.id}/history`);
        this.history = res.data.data || [];
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },

    money(val) {
      const num = parseFloat(val);
      if (isNaN(num)) return '-';
      return '₹' + num.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    },
  },
};
</script>

<template>
  <div class="modal fade" id="hrm_employee_salary_history_modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            Salary History
            <span v-if="employee" style="font-size:13px; color:#94a3b8; font-weight:500;">— {{ employee.name }}<template v-if="employee.code"> ({{ employee.code }})</template></span>
          </h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body">

          <div v-if="loading" class="text-center py-4 text-muted">
            <div class="spinner-border spinner-border-sm text-primary mb-2"></div>
            <div>Loading history...</div>
          </div>

          <div v-else-if="!history.length" class="text-center py-4 text-muted">
            <i class="ti ti-history d-block mb-2" style="font-size:30px; opacity:.4;"></i>
            No salary history found.
          </div>

          <div v-else class="es-timeline">
            <div
              v-for="(rec, idx) in history"
              :key="rec.id"
              class="es-tl-item"
              :class="{ 'es-tl-active': rec.is_active }"
            >
              <!-- dot + line -->
              <div class="es-tl-marker">
                <span class="es-tl-dot" :class="{ active: rec.is_active }"></span>
                <span v-if="idx !== history.length - 1" class="es-tl-line"></span>
              </div>

              <!-- card -->
              <div class="es-tl-card">
                <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-1">
                  <div class="d-flex align-items-center gap-2">
                    <span class="es-tl-ctc">{{ money(rec.ctc_annual) }}</span>
                    <span class="es-tl-mo">/ {{ money(rec.ctc_monthly) }} mo</span>
                  </div>
                  <span v-if="rec.is_active" class="es-badge es-active">Current</span>
                  <span v-else class="es-badge es-inactive">Closed</span>
                </div>
                <div class="es-tl-meta">
                  <span class="es-tl-struct">{{ rec.salary_structure?.name || '-' }}</span>
                  <span class="es-tl-dates">
                    <i class="ti ti-calendar me-1"></i>
                    {{ $formatDate(rec.effective_from) }}
                    <template v-if="rec.effective_to"> — {{ $formatDate(rec.effective_to) }}</template>
                    <template v-else> — present</template>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.es-timeline { padding: 4px 0; }

.es-tl-item { display: flex; gap: 14px; }

.es-tl-marker {
  display: flex; flex-direction: column; align-items: center;
  flex-shrink: 0; width: 14px;
}
.es-tl-dot {
  width: 13px; height: 13px; border-radius: 50%;
  background: #cbd5e1; border: 3px solid #e2e8f0; margin-top: 4px;
}
.es-tl-dot.active { background: #16a34a; border-color: #bbf7d0; }
.es-tl-line { flex: 1; width: 2px; background: #e2e8f0; margin: 3px 0; }

.es-tl-card {
  flex: 1; margin-bottom: 16px;
  background: #fff; border: 1px solid #e8edf3;
  border-radius: 10px; padding: 12px 14px;
}
.es-tl-active .es-tl-card { border-color: #bbf7d0; background: #f0fdf4; }

.es-tl-ctc { font-size: 15px; font-weight: 700; color: #0f172a; }
.es-tl-mo { font-size: 11.5px; color: #94a3b8; }

.es-tl-meta {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 6px;
}
.es-tl-struct {
  font-size: 11px; font-weight: 600;
  padding: 2px 9px; border-radius: 20px;
  background: #eef2ff; color: #4f46e5;
}
.es-tl-dates { font-size: 11px; color: #64748b; }

.es-badge {
  display: inline-block; font-size: 10px; font-weight: 600;
  padding: 3px 10px; border-radius: 20px;
}
.es-active { background: #dcfce7; color: #16a34a; }
.es-inactive { background: #f1f5f9; color: #94a3b8; }
</style>